import '@features/variation-templates/VariationTemplate1/styles/VariationTemplate1.module.css';

export const VariationTemplate1InputStyles = () => null;
